import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { iconMap } from './iconMap';
import {ReactComponent as DownIcon} from '../../../images/icons/Arrows/chevron-down.svg';

const isItemVisible = (item, { permissions, modules, exhibitDiver }) => {
    if (item.permission) {
        const perms = Array.isArray(item.permission) ? item.permission : [item.permission];
        const op = item.permissionOp || 'AND';
        const hasPermission = op === 'OR'
            ? perms.some(p => permissions.includes(p))
            : perms.every(p => permissions.includes(p));
        // condition (e.g. exhibitDiver) is OR-ed with the permission check
        const conditionMet = item.condition === 'exhibitDiver' ? !!exhibitDiver : false;
        if (!conditionMet && !hasPermission) return false;
    }
    if (item.module && !modules.includes(item.module)) return false;
    return true;
};

const NavMenuView = ({ items, permissions, modules, exhibitDiver, setOpenNav }) => {
    const location = useLocation();
    const [activeNav, setActiveNav] = useState(null);

    useEffect(() => {
        setActiveNav(location.pathname.split('/')[1] || null);
    }, [location.pathname]);

    const sorted = [...items]
        .filter(item => isItemVisible(item, { permissions, modules, exhibitDiver }))
        .sort((a, b) => a.position - b.position);

    return (
        <ul>
            {sorted.map(item => {
                const Icon = iconMap[item.icon];

                if (item.type === 'link') {
                    return (
                        <li key={item.id}>
                            <Link
                                to={item.path}
                                className={location.pathname === item.path ? 'active' : ''}
                                onClick={() => setOpenNav(false)}
                            >
                                {Icon && <Icon />}{item.label}
                            </Link>
                        </li>
                    );
                }

                if (item.type === 'submenu') {
                    const isOpen = activeNav === item.id;
                    const visibleChildren = [...(item.children || [])]
                        .filter(child => isItemVisible(child, { permissions, modules, exhibitDiver }))
                        .sort((a, b) => a.position - b.position);

                    if (visibleChildren.length === 0) return null;

                    return (
                        <li key={item.id} className={isOpen ? 'open' : ''}>
                            <span onClick={() => setActiveNav(isOpen ? null : item.id)}>
                                {Icon && <Icon />}
                                {item.label}
                                <DownIcon />
                            </span>
                            <ul>
                                {visibleChildren.map(child => {
                                    const ChildIcon = iconMap[child.icon];
                                    return (
                                        <li key={child.id}>
                                            <Link
                                                to={child.path}
                                                className={location.pathname === child.path ? 'active' : ''}
                                                onClick={() => setOpenNav(false)}
                                            >
                                                {ChildIcon && <ChildIcon />}{child.label}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </li>
                    );
                }

                return null;
            })}
        </ul>
    );
};

export default NavMenuView;
